// removed by extract-text-webpack-plugin
module.exports = {"link":"cart-module_link_3PTqY","item":"cart-module_item_5OpVh","icon":"cart-module_icon_2AXc6","amount":"cart-module_amount_-b7eY","hidden":"cart-module_hidden_bzacv"};


//////////////////
// WEBPACK FOOTER
// ./client/components/siteHeader/header/cart.module.css
// module id = 400
// module chunks = 1 2